
if (!customElements.get('nolvya-planner-v19')) {
 const NP_BLOBS = new Map();
 // Les images intégrées sont converties une seule fois en adresse locale (plus léger pour le navigateur).
 const npBlob = uri => {
  if (!uri || !uri.startsWith('data:')) return uri;
  if (NP_BLOBS.has(uri)) return NP_BLOBS.get(uri);
  try {
   const [head, b64] = uri.split(','), mime = head.slice(5).split(';')[0], bin = atob(b64), bytes = new Uint8Array(bin.length);
   for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
   const url = URL.createObjectURL(new Blob([bytes], {type: mime}));
   NP_BLOBS.set(uri, url); return url;
  } catch (error) { return uri; }
 };
 const SVG = 'http://www.w3.org/2000/svg';
 customElements.define('nolvya-planner-v19', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.section = this.closest('.np-section');
   this.data = this.section._npData || (this.section._npData = JSON.parse(this.section.querySelector('.np-data').textContent));
   Object.assign(this.data.furnitureLabels,{bed90:'Lit de 90 cm',bed160:'Lit de 160 cm',bed180:'Lit de 180 cm',four:'4 personnes',six:'6 personnes',eight:'8 personnes'});
   this.card = this.dataset.mode === 'card';
   this.rooms = this.card ? [this.dataset.room] : ['salon', 'dining', 'bedroom'];
   this.room = this.card ? this.dataset.room : (this.rooms.includes(this.data.defaultRoom) ? this.data.defaultRoom : 'salon');
   this.stage = this.querySelector('.np-stage');
   this.modelSelect = this.querySelector('.np-model');
   this.sizesElement = this.querySelector('.np-sizes');
   this.furnitureSelect = this.querySelector('.np-furniture-select');
   this.choice = {salon: 'auto', dining: 'auto', bedroom: 'auto'};
   this.modelIndex = 0; this.loadToken = 0;
   this.models = this.data.onProduct ? [] : this.data.models.filter(model => model.image && (!this.section.querySelector('.np-catalog') || model.url));
   if (!this.models.length) this.models = [{title: this.data.baseProduct?.title || this.data.demoName, image: this.data.defaultImage, sizes: this.data.onProduct ? '' : this.data.manualSizes, url: this.data.baseProduct?.url, variants: this.data.baseProduct?.variants || []}];
   if (this.modelSelect) {
    this.modelSelect.replaceChildren();
    for (const [index, model] of this.models.entries()) this.modelSelect.add(new Option(model.title, String(index)));
    this.querySelector('.np-model-field').hidden = this.models.length < 2;
   }
   this.buildStage();
   this.buildFurniture();
   if (this.data.atlasHd) {
    // Meubles en haute définition si le fichier est présent dans le thème.
    const hd = new Image();
    hd.onload = () => { if (Math.abs(hd.naturalWidth / hd.naturalHeight - 1) > .02 || !this.isConnected) return; this.atlasUrl = this.data.atlasHd; for (const image of this.stage.querySelectorAll('.np-object image[data-atlas]')) image.setAttribute('href', this.atlasUrl); };
    hd.src = this.data.atlasHd;
   }
   this.onClick = event => {
    const roomButton = event.target.closest('[data-room]');
    if (roomButton && !this.card && this.contains(roomButton) && roomButton.tagName === 'BUTTON') { this.stopAuto(); this.room = roomButton.dataset.room; this.furnitureOptions(); this.render(); return; }
    const moreButton = event.target.closest('[data-np-size-toggle]');
    if (moreButton && this.contains(moreButton)) { this.stopAuto(); this.sizesExpanded = !this.sizesExpanded; this.updateSizeVisibility(); return; }
    const furnitureButton=event.target.closest('[data-furniture]');
    if(furnitureButton&&this.contains(furnitureButton)){this.stopAuto();this.choice[this.room]=furnitureButton.dataset.furniture;if(this.furnitureSelect)this.furnitureSelect.value=this.choice[this.room];this.render();return;}
    const sizeButton = event.target.closest('[data-size]');
    if (sizeButton && this.sizesElement?.contains(sizeButton)) { this.stopAuto(); this.size = this.sizes[Number(sizeButton.dataset.size)]; this.choice[this.room] = 'auto'; if(this.furnitureSelect)this.furnitureSelect.value='auto'; this.camCache=null; this.render(); }
   };
   this.onModel = () => { this.stopAuto(); this.selectModel(Number(this.modelSelect.value)); };
   this.onFurniture = () => { this.stopAuto(); this.choice[this.room] = this.furnitureSelect.value; this.render(); };
   this.addEventListener('click', this.onClick);
   this.modelSelect?.addEventListener('change', this.onModel);
   this.furnitureSelect?.addEventListener('change', this.onFurniture);
   this.viewportWidth = window.innerWidth;
   this.onResize = () => { if(window.innerWidth === this.viewportWidth)return; this.viewportWidth = window.innerWidth; this.camCache = null; this.furnitureOptions(); this.updateSizeVisibility(); this.render(); };
   window.addEventListener('resize', this.onResize, {passive: true});
   this.furnitureOptions();
   this.selectModel(0);
   requestAnimationFrame(()=>this.isConnected&&this.setupCatalog());
   this.setupAutoplay();
  }

  setupCatalog() {
   if(this.data.onProduct || this.section.dataset.catalogReady==='true')return;
   const picker=this.section.querySelector('.np-catalog');if(!picker)return;
   this.section.dataset.catalogReady='true';
   const actions=this.section.querySelector('.np-bottom-actions'),top=picker.querySelector('.np-catalog-top');
   if(actions&&top){
    const parent=actions.parentNode,next=actions.nextSibling;
    this.catalogMedia=window.matchMedia('(max-width:749px)');
    this.onCatalogLayout=()=>{if(this.catalogMedia.matches)parent.insertBefore(actions,next);else top.append(actions);};
    this.catalogMedia.addEventListener('change',this.onCatalogLayout);
    this.onCatalogLayout();
   }
   const groups=[...new Set(this.models.map(model=>model.group).filter(Boolean))],tabs=picker.querySelector('.np-collections'),list=picker.querySelector('.np-products');
   let group=groups[0]||'',selected=0;
   const update=()=>{
    for(const button of tabs.children)button.setAttribute('aria-pressed',String(button.dataset.group===group));
    for(const button of list.children){button.hidden=!!group&&this.models[Number(button.dataset.modelIndex)].group!==group;button.setAttribute('aria-pressed',String(Number(button.dataset.modelIndex)===selected));}
   };
   for(const name of groups){const b=document.createElement('button');b.type='button';b.dataset.group=name;b.textContent=name;tabs.append(b);}
   for(const [index,model]of this.models.entries()){
    const b=document.createElement('button');b.type='button';b.className='np-product-choice';b.dataset.modelIndex=String(index);
    const image=document.createElement('img');image.src=model.thumbnail||model.image;image.alt='';image.width=60;image.height=72;image.loading='lazy';image.decoding='async';
    const title=document.createElement('span');title.textContent=model.title;b.append(image,title);list.append(b);
   }
   const select=index=>{
    selected=index;
    for(const planner of this.section.querySelectorAll('nolvya-planner-v19')){planner.selectModel(index);planner.autoStopped=false;clearTimeout(planner.autoTimer);planner.autoTimer=setTimeout(()=>planner.autoStep(),planner.autoInterval||5000);}
    const model=this.models[index],link=this.section.querySelector('.np-catalog-actions .np-discover');if(link){link.href=model.url;link.hidden=!model.url;}
    picker.querySelector('.np-current-product').textContent=this.data.selectedLabel+' '+model.title;
    update();
   };
   picker.addEventListener('click',event=>{const tab=event.target.closest('[data-group]'),button=event.target.closest('[data-model-index]');if(tab){group=tab.dataset.group;const index=this.models.findIndex(m=>m.group===group);if(index>=0)select(index);}else if(button)select(Number(button.dataset.modelIndex));});
   this.section.addEventListener('click',event=>{const pause=event.target.closest('[data-np-pause]');if(!pause)return;const paused=pause.getAttribute('aria-pressed')!=='true';pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?this.data.playLabel:this.data.pauseLabel);for(const planner of this.section.querySelectorAll('nolvya-planner-v19')){if(paused)planner.stopAuto();else{planner.autoStopped=false;planner.autoTimer=setTimeout(()=>planner.autoStep(),planner.autoInterval||5000);}}});
   select(0);
  }

  buildStage() {
   this.stage.replaceChildren();
   for (const room of this.rooms) {
    const floor = document.createElement('div');
    floor.className = 'np-floor'; floor.dataset.for = room;
    this.setFloor(floor, this.data.floors?.[room] || this.data.floorPhoto);
    this.stage.append(floor);
   }
   this.rug = document.createElement('div'); this.rug.className = 'np-rug';
   const svg = document.createElementNS(SVG, 'svg');
   svg.setAttribute('viewBox', '0 0 100 100'); svg.setAttribute('preserveAspectRatio', 'none'); svg.setAttribute('aria-hidden', 'true');
   this.rugImages = [0, 1].map(() => {
    const image = document.createElementNS(SVG, 'image');
    image.setAttribute('class', 'np-rug-image'); image.setAttribute('width', '100'); image.setAttribute('height', '100'); image.setAttribute('preserveAspectRatio', 'none');
    image.dataset.active = 'false'; svg.append(image); return image;
   });
   this.activeImage = 0;
   this.rug.append(svg); this.stage.append(this.rug);
   for (const room of this.rooms) {
    const layer = document.createElement('div'); layer.className = 'np-furniture'; layer.dataset.for = room;
    this.stage.append(layer);
   }
   this.measure = document.createElement('span'); this.measure.className = 'np-measure'; this.measure.setAttribute('aria-hidden', 'true');
   this.stage.append(this.measure);
  }
  setFloor(floor, photo) {
   // Photo de parquet (avec la lumière du jour déjà dans l'image) ; parquet intégré si elle est introuvable.
   const builtIn = () => { floor.dataset.photo = 'false'; floor.style.backgroundImage = `url("${npBlob(this.data.floor)}")`; this.render(); };
   if (!photo) { builtIn(); return; }
   floor.dataset.photo = 'true';
   floor.style.backgroundImage = `url("${photo}")`;
   const probe = new Image(); probe.onload = () => { this.floorRatio = probe.naturalHeight / probe.naturalWidth || 1; this.render(); }; probe.onerror = builtIn; probe.src = photo;
  }
  parseSize(text) { return window.NolvyaSizes.parse(text); }
  getSizes(model) {
   const unique = new Map(), linked = this.data.onProduct || !!model.url;
   const add = text => { const size = this.parseSize(text); if (size) unique.set(size.label, size); };
   if (linked || !model.sizes?.trim()) for (const variant of model.variants || []) {
    const size = (variant.options || []).map(value => this.parseSize(value)).find(Boolean) || this.parseSize(variant.title);
    if (size && (!unique.has(size.label) || variant.available)) unique.set(size.label, {...size, variantId: variant.id, available: variant.available});
   }
   if (!unique.size && !this.data.onProduct && model.sizes?.trim()) model.sizes.split(/[\n;]+/).forEach(add);
   if (!unique.size && !linked) (this.data.fallbackSizes || '').split(/[\n;]+/).forEach(add);
   return window.NolvyaSizes.useful([...unique.values()].sort((a, b) => a.width * a.length - b.width * b.length));
  }
  selectModel(index) {
   this.choice = {salon:'auto',dining:'auto',bedroom:'auto'};
   this.modelIndex = Math.max(0, Math.min(this.models.length - 1, index));
   if (this.modelSelect) this.modelSelect.value = String(this.modelIndex);
   const model = this.models[this.modelIndex];
   const previous = this.size?.label || this.parseSize(this.data.defaultSize)?.label;
   this.sizes = this.getSizes(model);
   this.camCache = null;
   if (this.card) {
    const cycle = this.cycleSizes(), index = [...this.section.querySelectorAll('nolvya-planner-v19')].indexOf(this);
    this.size = cycle.length ? cycle[(Math.max(0, index) * 3 + 1) % cycle.length] : null;
   } else {
    this.size = this.sizes.find(size => size.label === previous) || this.sizes.reduce((best, size) => !best || Math.abs(size.width * size.length - 36800) < Math.abs(best.width * best.length - 36800) ? size : best, null);
   }
   this.stage.hidden = !this.size;
   const empty = this.querySelector('.np-size-empty'); if (empty) empty.hidden = !!this.size;
   if (this.sizesElement) {
    this.sizesElement.replaceChildren();
    this.sizesExpanded = false;
    this.sizeMore?.remove();
    this.sizeMore = document.createElement('button');
    this.sizeMore.type = 'button'; this.sizeMore.className = 'np-size-more'; this.sizeMore.dataset.npSizeToggle = '';
    this.sizeMore.setAttribute('aria-expanded', 'false');
    this.sizesElement.id ||= 'np-sizes-' + this.section.id + '-' + [...this.section.querySelectorAll('nolvya-planner-v19')].indexOf(this);
    this.sizeMore.setAttribute('aria-controls', this.sizesElement.id);
    this.sizesElement.after(this.sizeMore);
    for (const [i, size] of this.sizes.entries()) {
     const button = document.createElement('button');
     button.type = 'button'; button.className = 'np-size'; button.dataset.size = String(i);
     button.setAttribute('aria-pressed', 'false');
     const swatch = document.createElement('i'); swatch.setAttribute('aria-hidden', 'true');
     swatch.style.width = `${Math.round(6 + size.length / 25)}px`; swatch.style.height = `${Math.round(4 + size.width / 25)}px`;
     button.append(swatch, document.createTextNode(size.label));
     this.sizesElement.append(button);
    }
   }
   this.updateSizeVisibility();
   this.loadImage(model.image || this.data.defaultImage);
   this.render();
  }
  compactMobile() { return this.card && window.matchMedia('(max-width:749px)').matches; }
  mobileSizes() {
   const available = this.sizes || [], result = [];
   const targets = [[80,120],[140,200],[160,230],[200,400]];
   for (const [width,length] of targets) {
    const candidates = available.filter(size => !result.includes(size));
    const nearest = candidates.reduce((best,size) => {
     const score = Math.abs(Math.log(size.width/width)) + Math.abs(Math.log(size.length/length));
     return !best || score < best.score ? {size,score} : best;
    },null);
    if (nearest) result.push(nearest.size);
   }
   return result.sort((a,b)=>a.width*a.length-b.width*b.length);
  }
  updateSizeVisibility() {
   if (!this.sizesElement) return;
   const buttons = [...this.sizesElement.querySelectorAll('button[data-size]')];
   const mobile=this.compactMobile();
   const showNine=this.data.onProduct && !this.card && buttons.length===9 && window.matchMedia('(min-width:768px)').matches;
   const picks=showNine?buttons:mobile?this.mobileSizes().map(size=>buttons[this.sizes.indexOf(size)]):buttons.length<=8?buttons:window.NolvyaSizes.spaced(this.sizes,6).map(size=>buttons[this.sizes.indexOf(size)]);
   const visible = new Set(picks);
   const selected = buttons.find(button => this.sizes[Number(button.dataset.size)]?.label === this.size?.label);
   if (!mobile && selected && !visible.has(selected)) { if(visible.size>=6)visible.delete(picks[Math.max(0,picks.length-2)]); visible.add(selected); }
   for (const button of buttons) button.hidden = !this.sizesExpanded && !visible.has(button);
   if (this.sizeMore) {
    this.sizeMore.hidden = visible.size >= buttons.length;
    this.sizeMore.setAttribute('aria-expanded', String(!!this.sizesExpanded));
    this.sizeMore.textContent = this.sizesExpanded ? 'Réduire le choix de tailles' : 'Voir toutes les tailles (' + buttons.length + ')';
   }
  }
  prepareImage(url) {
   this.constructor.imageCache ||= new Map();
   const cache = this.constructor.imageCache;
   if (!cache.has(url)) {
    const promise = new Promise((resolve, reject) => {
     const img = new Image(); img.decoding = 'async';
     if (!url.startsWith('data:') && !url.startsWith('blob:')) img.crossOrigin = 'anonymous';
     img.onload = () => Promise.resolve(img.decode?.()).catch(() => {}).then(() => { img.trim = this.findRug(img); resolve(img); });
     img.onerror = () => {
      // Si le serveur refuse la lecture de l'image, on la recharge sans recadrage automatique.
      if (img.crossOrigin) { img.crossOrigin = null; img.removeAttribute('crossorigin'); img.src = url + (url.includes('?') ? '&' : '?') + 'np=1'; return; }
      reject(new Error('image'));
     };
     img.src = url;
    });
    cache.set(url, promise); promise.catch(() => cache.delete(url));
   }
   return cache.get(url);
  }
  findRug(img) {
   // Repère le tapis dans l'image (marges transparentes ou blanches ignorées)
   // pour qu'il remplisse exactement ses dimensions, quel que soit le cadrage de la photo.
   try {
    const k = Math.min(1, 400 / Math.max(img.naturalWidth, img.naturalHeight)), w = Math.max(1, Math.round(img.naturalWidth * k)), h = Math.max(1, Math.round(img.naturalHeight * k));
    const canvas = document.createElement('canvas'); canvas.width = w; canvas.height = h;
    const context = canvas.getContext('2d', {willReadFrequently: true}); context.drawImage(img, 0, 0, w, h);
    const d = context.getImageData(0, 0, w, h).data, at = (x, y) => (y * w + x) * 4;
    const corners = [at(0, 0), at(w - 1, 0), at(0, h - 1), at(w - 1, h - 1)];
    const whiteBackground = corners.every(i => d[i + 3] > 200 && d[i] > 238 && d[i + 1] > 238 && d[i + 2] > 238);
    const blank = i => d[i + 3] < 24 || (whiteBackground && d[i] > 238 && d[i + 1] > 238 && d[i + 2] > 238);
    const rowFull = y => { let n = 0; for (let x = 0; x < w; x++) if (!blank(at(x, y))) n++; return n > w * .04; };
    const colFull = x => { let n = 0; for (let y = 0; y < h; y++) if (!blank(at(x, y))) n++; return n > h * .04; };
    let t = 0, b = h - 1, l = 0, r = w - 1;
    while (t < b && !rowFull(t)) t++; while (b > t && !rowFull(b)) b--;
    while (l < r && !colFull(l)) l++; while (r > l && !colFull(r)) r--;
    const box = {l: l / w, t: t / h, r: (r + 1) / w, b: (b + 1) / h};
    if (box.r - box.l < .2 || box.b - box.t < .2) return null;
    return box;
   } catch (error) { return null; }
  }
  fitRug(image, trim) {
   const box = trim || {l: 0, t: 0, r: 1, b: 1}, w = 100 / (box.r - box.l), h = 100 / (box.b - box.t);
   image.setAttribute('width', String(w)); image.setAttribute('height', String(h));
   image.setAttribute('x', String(-box.l * w)); image.setAttribute('y', String(-box.t * h));
  }
  async loadImage(url) {
   const token = ++this.loadToken;
   try {
    const img = await this.prepareImage(url);
    if (token !== this.loadToken || !this.isConnected) return;
    const next = 1 - this.activeImage;
    this.fitRug(this.rugImages[next], img.trim);
    this.rugImages[next].setAttribute('href', url);
    await new Promise(requestAnimationFrame);
    if (token !== this.loadToken || !this.isConnected) return;
    this.rugImages[next].dataset.active = 'true';
    this.rugImages[this.activeImage].dataset.active = 'false'; this.activeImage = next;
    const error = this.querySelector('.np-error'); if (error) error.hidden = true;
   } catch (error) { const notice = this.querySelector('.np-error'); if (token === this.loadToken && this.isConnected && notice) notice.hidden = false; }
  }
  furnitureOptions() {
   if (!this.furnitureSelect) return;
   const mobile=this.card;
   const keys = this.room === 'salon' ? ['two', 'three', 'corner'] : this.room === 'dining' ? ['four', 'six', 'eight'] : ['bed90','bed160','bed180'];
   if(this.room==='bedroom' && this.choice.bedroom==='bed140') this.choice.bedroom='bed160';
   this.furnitureSelect.replaceChildren();
   this.furnitureSelect.add(new Option(this.data.furnitureLabels.auto, 'auto'));
   for (const key of keys) this.furnitureSelect.add(new Option(this.data.furnitureLabels[key], key));
   this.furnitureSelect.value = this.choice[this.room];
   let choices=this.querySelector('.np-furniture-choices');
   if(!choices){choices=document.createElement('div');choices.className='np-furniture-choices';choices.setAttribute('role','group');choices.setAttribute('aria-label',this.data.furnitureGroupLabel);this.furnitureSelect.after(choices);}
   choices.replaceChildren();
   for(const key of keys){const button=document.createElement('button');button.type='button';button.dataset.furniture=key;button.textContent=this.data.furnitureLabels[key];button.setAttribute('aria-label',this.data.furnitureLabels[key]);button.setAttribute('aria-pressed',String(this.choice[this.room]===key));choices.append(button);}
   this.furnitureSelect.hidden=true;
   const label=this.furnitureSelect.closest('.np-field')?.querySelector('label');if(label)label.hidden=true;
  }
  autoType(size) {
   // Mobilier proposé automatiquement selon la longueur du tapis (cm).
   const n = size?.length || 290;
   if (this.room === 'salon') return n >= 300 ? 'corner' : n >= 220 ? 'three' : 'two';
   if (this.room === 'dining') return n >= 280 ? 'eight' : n >= 250 ? 'six' : 'four';
   return n>=290?'bed180':n>=200?'bed160':'bed90';
  }
  furnitureType() {
   if (this.choice[this.room] !== 'auto') return this.choice[this.room];
   return this.autoType(this.size);
  }
  layout(type, size) {
   // Plan vu du dessus en centimètres réels : tapis et meubles à la même échelle.
   const rugW = size.length, rugH = size.width, items = {}, box = (x, y, w, h, rot = 0) => ({x, y, w, h, rot});
   let rug;
   if (this.room === 'salon') {
    const [sw, sd] = {two: [160, 84], three: [220, 100], corner: [270, 226]}[type] || [160, 84];
    const seat = type === 'corner' ? 95 : sd;
    for (const k of ['sofaTwo', 'sofa', 'corner']) items[k] = box(-sw / 2, 0, sw, sd);
    items.sofaTwo.visible = type === 'two'; items.sofa.visible = type === 'three'; items.corner.visible = type === 'corner';
    rug = box(-rugW / 2, seat - 25, rugW, rugH);
    const c = type === 'corner' ? 80 : 72, cx = type === 'corner' ? -30 : 0;
    items.coffee = box(cx - c / 2, seat + 42, c, c);
   } else if (this.room === 'dining') {
    const four = type === 'four', tw = four ? 140 : 190, td = four ? 80 : 95, per = four ? 2 : 3, chW = 44, chD = 53, tuck = 12;
    items.table = box(-tw / 2, -td / 2, tw, td);
    for (let i = 0; i < 8; i++) items[`chair${i}`] = {...box(0, 0, chW, chD), visible: false};
    for (let i = 0; i < per; i++) {
     const x = -tw / 2 + (i + .5) * tw / per - chW / 2;
     items[`chair${i}`] = box(x, -td / 2 - chD + tuck, chW, chD, 0);
     items[`chair${i + 3}`] = box(x, td / 2 - tuck, chW, chD, 180);
    }
    if (type === 'eight') {
     items.chair6 = box(-tw / 2 - chD / 2 + tuck - chW / 2, -chD / 2, chW, chD, -90);
     items.chair7 = box(tw / 2 + chD / 2 - tuck - chW / 2, -chD / 2, chW, chD, 90);
    }
    rug = box(-rugW / 2, -rugH / 2, rugW, rugH);
   } else {
    const single = type === 'bed90', bw = single ? 92 : (Number(type.replace('bed', '')) || 160) + 12, bl = 210;
    items.bedSingle = box(-bw / 2, 0, bw, bl); items.bedSingle.visible = single;
    items.bed = box(-bw / 2, 0, bw, bl); items.bed.visible = !single;
    items.nightLeft = box(-bw / 2 - 12 - 45, 6, 45, 45);
    items.nightRight = box(bw / 2 + 12, 6, 45, 45); items.nightRight.visible = !single;
    // Haut du tapis sous le dernier tiers du lit ; un petit tapis reste visible au pied du lit.
    rug = box(-rugW / 2, Math.max(bl * .6, bl - rugH * .4), rugW, rugH);
   }
   for (const item of Object.values(items)) if (item.visible === undefined) item.visible = true;
   return {rug, items};
  }
  frameRatio() {
   if (this.card) return 1.08;
   return window.matchMedia('(max-width: 749px)').matches ? 1 : 1.14;
  }
  fit(boxes, ratio) {
   let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
   for (const b of boxes) { x0 = Math.min(x0, b.x); y0 = Math.min(y0, b.y); x1 = Math.max(x1, b.x + b.w); y1 = Math.max(y1, b.y + b.h); }
   const zoom = {close: [300, 40], balanced: [400, 52], wide: [500, 64]}[this.data.zoom] || [400, 52];
   const narrow = window.matchMedia('(max-width: 749px)').matches;
   const minW = zoom[0] * (narrow && !this.card ? .9 : 1), margin = zoom[1];
   let w = Math.max(x1 - x0 + margin * 2, minW), h = Math.max(y1 - y0 + margin * 2, minW / ratio);
   if (w / h < ratio) w = h * ratio;
   return {cx: (x0 + x1) / 2, cy: (y0 + y1) / 2 + margin * .12, w};
  }
  cameraFor() {
   // Cadrage par famille de mobilier : entre deux tailles d'une même famille, le cadre ne bouge pas
   // et seul le tapis change. Une taille plus grande ne paraît jamais plus petite à l'écran.
   const ratio = this.frameRatio(), key = [this.room, this.choice[this.room], ratio, this.modelIndex, this.sizes.length].join('|');
   if (this.camCache?.key !== key) {
    const table = new Map(); let previous = 0;
    for (const size of this.sizes) {
     const type = this.choice[this.room] !== 'auto' ? this.choice[this.room] : this.autoType(size);
     const plan = this.layout(type, size), furniture = Object.values(plan.items).filter(item => item.visible);
     const group = this.sizes.filter(other => this.autoType(other) === this.autoType(size));
     const wide = this.fit([...furniture, plan.rug, ...group.map(other => this.layout(type, other).rug)], ratio);
     const tight = this.fit([...furniture, plan.rug], ratio);
     const measure = Math.sqrt(size.width * size.length);
     let w = wide.w, center = wide;
     if (previous && measure / w < previous * 1.06) { w = Math.max(tight.w, measure / (previous * 1.06)); center = tight; }
     previous = measure / w;
     table.set(size.label, {x: center.cx - w / 2, y: center.cy - w / ratio / 2, w, h: w / ratio, ratio});
    }
    this.camCache = {key, table};
   }
   return this.camCache.table.get(this.size.label);
  }
  motionDuration() { return this.slow ? 1100 : 460; }
  render() {
   if (this.renderFrame) return;
   this.renderFrame = requestAnimationFrame(() => {
    this.renderFrame = 0; if (!this.isConnected) return;
    const nodes = [this.rug, ...this.querySelectorAll('.np-furniture[data-active="true"] .np-object')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const before = this.hasRendered && !reduced ? nodes.map(node => [node, node.getBoundingClientRect()]) : [];
    for (const animation of this.motion || []) animation.cancel();
    this.renderNow();
    const after = before.map(([node, rect]) => [node, rect, node.getBoundingClientRect()]);
    const duration = this.motionDuration();
    this.motion = [];
    for (const [node, a, b] of after) {
     if (!a.width || !a.height || !b.width || !b.height || !node.animate) continue;
     const dx = a.x + a.width / 2 - b.x - b.width / 2, dy = a.y + a.height / 2 - b.y - b.height / 2;
     const sx = a.width / b.width, sy = a.height / b.height;
     if (Math.abs(dx) + Math.abs(dy) + Math.abs(sx - 1) + Math.abs(sy - 1) < .01) continue;
     const end = node.style.transform || 'none', rotation = end === 'none' ? '' : end;
     this.motion.push(node.animate([{transform: `translate(${dx}px,${dy}px) scale(${sx},${sy}) ${rotation}`}, {transform: end}], {duration, easing: 'cubic-bezier(.22,.61,.36,1)'}));
    }
    this.hasRendered = true;
   });
  }
  renderNow() {
   if (!this.size) return;
   const type = this.furnitureType(), plan = this.layout(type, this.size), cam = this.cameraFor(); this.camera = cam;
   const stageWidth = this.stage.clientWidth || cam.w, scale = stageWidth / cam.w;
   this.stage.style.aspectRatio = `${cam.ratio}`;
   this.stage.style.setProperty('--np-move', `${this.motionDuration()}ms`);
   this.stage.style.setProperty('--np-s', String(Math.max(.35, scale).toFixed(3)));
   const place = (el, b) => { el.style.left = `${(b.x - cam.x) / cam.w * 100}%`; el.style.top = `${(b.y - cam.y) / cam.h * 100}%`; el.style.width = `${b.w / cam.w * 100}%`; el.style.height = `${b.h / cam.h * 100}%`; };
   this.rug.dataset.shape = this.size.round ? 'round' : 'rect';
   place(this.rug, plan.rug);
   for (const button of this.querySelectorAll('button[data-room]')) button.setAttribute('aria-pressed', String(button.dataset.room === this.room));
   for (const layer of this.stage.querySelectorAll('.np-floor,.np-furniture')) layer.dataset.active = String(layer.dataset.for === this.room);
   if (this.sizesElement) for (const [i, button] of [...this.sizesElement.children].entries()) button.setAttribute('aria-pressed', String(this.sizes[i].label === this.size.label));
   this.updateSizeVisibility();
   const objects = this.objects[this.room] || {}, boxes = [plan.rug];
   for (const [name, el] of Object.entries(objects)) {
    const item = plan.items[name]; if (!item) continue;
    place(el, item); el.style.transform = `rotate(${item.rot || 0}deg)`; el.style.opacity = item.visible ? '1' : '0';
    if (item.visible) boxes.push(item);
   }
   // Buffet et plante dans les angles du cadre, seulement s'ils ne cachent rien.
   const hit = (a, b) => a.x < b.x + b.w + 6 && a.x + a.w + 6 > b.x && a.y < b.y + b.h + 6 && a.y + a.h + 6 > b.y;
   const inset = Math.min(22, cam.w * .045);
   const decor = {plant: {x: cam.x + cam.w - inset - 58, y: cam.y + inset * .7, w: 58, h: 58}, sideboard: {x: cam.x + inset, y: cam.y + inset * .5, w: 120, h: 44}};
   for (const [name, b] of Object.entries(decor)) {
    const el = objects[name]; if (!el) continue;
    place(el, b); el.style.transform = 'rotate(0deg)'; el.style.opacity = boxes.some(other => hit(b, other)) ? '0' : '1';
   }
   // Le parquet suit la même échelle que le tapis et les meubles (planches de 22 cm).
   const tile = 440 * scale, stageHeight = stageWidth / cam.ratio;
   for (const floor of this.stage.querySelectorAll('.np-floor')) {
    if (floor.dataset.photo === 'true') {
     // La photo représente environ 5,2 m de sol : elle suit le zoom sans jamais laisser de bord vide.
     const ratio = this.floorRatio || 1;
     let fw = Math.max(520 * scale, stageWidth, stageHeight / ratio), fh = fw * ratio;
     const x = Math.min(0, Math.max(stageWidth - fw, (0 - cam.x) * scale - fw / 2));
     const y = Math.min(0, Math.max(stageHeight - fh, (cam.y + cam.h / 2 - cam.y) * scale - fh / 2));
     floor.style.backgroundSize = `${fw}px ${fh}px`;
     floor.style.backgroundPosition = `${x}px ${y}px`;
     continue;
    }
    floor.style.backgroundSize = `${tile}px ${tile}px`;
    floor.style.backgroundPosition = `${(-220 - cam.x) * scale}px ${(-160 - cam.y) * scale}px`;
   }
   for(const button of this.querySelectorAll('[data-furniture]'))button.setAttribute('aria-pressed',String(button.dataset.furniture===type));
   const label = this.data.furnitureLabels[type];
   this.measure.textContent = `${this.size.label} cm`;
   const recommendation = this.querySelector('.np-recommendation');
   if (recommendation) recommendation.textContent = this.card ? `${label} · ${this.size.label} cm` : `${label}. ${this.data.advice[this.room]}`;
   this.stage.setAttribute('aria-label', `${this.data.labels[this.room]} — ${this.size.label} cm — ${label}`);
   const model = this.models[this.modelIndex], link = this.card ? null : this.querySelector('.np-discover');
   if (link) {
    link.hidden = !model.url;
    if (model.url) { const url = new URL(model.url, window.location.origin); if (this.size.variantId) url.searchParams.set('variant', this.size.variantId); link.href = url.pathname + url.search; }
   }
  }
  buildFurniture() {
   const cells = {sofa: [18, 145, 424, 246], corner: [442, 82, 450, 377], coffee: [912, 112, 323, 322], table: [20, 560, 445, 260], chair: [522, 500, 273, 330], bed: [889, 462, 330, 435], night: [85, 918, 254, 255], plant: [433, 847, 356, 351], sideboard: [809, 963, 428, 180]};
   cells.sofaTwo = this.data.sofaTwo.box; cells.bedSingle = this.data.bedSingle.box;
   const objects = {salon: {sofaTwo: 'sofaTwo', sofa: 'sofa', corner: 'corner', coffee: 'coffee', plant: 'plant', sideboard: 'sideboard'}, dining: {}, bedroom: {bedSingle: 'bedSingle', bed: 'bed', nightLeft: 'night', nightRight: 'night', plant: 'plant', sideboard: 'sideboard'}};
   for (let i = 0; i < 8; i++) objects.dining[`chair${i}`] = 'chair';
   Object.assign(objects.dining, {table: 'table', plant: 'plant', sideboard: 'sideboard'});
   const stretch = ['sofa', 'sofaTwo', 'corner', 'table', 'bed', 'bedSingle'];
   const atlas = this.atlasUrl || npBlob(this.data.atlas), sofaTwo = npBlob(this.data.sofaTwo.image), bedSingle = npBlob(this.data.bedSingle.image);
   this.objects = {};
   this.uid = this.uid || Math.random().toString(36).slice(2, 8);
   for (const room of this.rooms) {
    const parent = this.stage.querySelector(`.np-furniture[data-for="${room}"]`);
    if (!parent) continue;
    parent.replaceChildren();
    this.objects[room] = {};
    for (const [name, kind] of Object.entries(objects[room])) {
     const element = document.createElement('div'); element.className = 'np-object'; element.dataset.name = name; element.setAttribute('aria-hidden', 'true');
     if (kind === 'table') element.style.zIndex = '2';
     const svg = document.createElementNS(SVG, 'svg'); svg.setAttribute('viewBox', cells[kind].join(' '));
     if (stretch.includes(kind)) svg.setAttribute('preserveAspectRatio', 'none');
     const asset = kind === 'sofaTwo' ? {image: sofaTwo, width: this.data.sofaTwo.width, height: this.data.sofaTwo.height} : kind === 'bedSingle' ? {image: bedSingle, width: this.data.bedSingle.width, height: this.data.bedSingle.height} : {image: atlas, width: 1254, height: 1254};
     const image = document.createElementNS(SVG, 'image'); image.setAttribute('href', asset.image); if (asset.image === atlas) image.dataset.atlas = '1'; image.setAttribute('width', String(asset.width)); image.setAttribute('height', String(asset.height));
     const clipId = `np-${this.uid}-${room}-${name}`;
     const defs = document.createElementNS(SVG, 'defs');
     const clip = document.createElementNS(SVG, 'clipPath'); clip.setAttribute('id', clipId); clip.setAttribute('clipPathUnits', 'userSpaceOnUse');
     const rect = document.createElementNS(SVG, 'rect');
     ['x', 'y', 'width', 'height'].forEach((attribute, i) => rect.setAttribute(attribute, String(cells[kind][i])));
     clip.append(rect); defs.append(clip); image.setAttribute('clip-path', `url(#${clipId})`);
     svg.append(defs, image); element.append(svg); parent.append(element); this.objects[room][name] = element;
    }
   }
  }
  cycleSizes() {
   if(this.compactMobile())return this.mobileSizes();
   // Tailles montrées pendant le défilement automatique : de la plus petite utile à la plus grande.
   let list = (this.sizes || []).filter(size => size.width >= 120 && size.length >= 160);
   if (list.length < 2) list = window.NolvyaSizes.useful(this.sizes || []);
   if (list.length <= 4) return list;
   const picks = [0, 1, 2, 3].map(k => list[Math.round(k * (list.length - 1) / 3)]);
   return [...new Set(picks)];
  }
  setupAutoplay() {
   if (!this.data.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
   const all = [...this.section.querySelectorAll('nolvya-planner-v19')], index = Math.max(0, all.indexOf(this));
   // Chaque pièce a son propre rythme : les changements ne tombent jamais en même temps.
   this.autoInterval = Math.max(3, Number(this.data.interval) || 5) * 1000 * (1 + index * .23);
   this.visible = false;
   if ('IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(entries => { this.visible = entries.some(entry => entry.isIntersecting); }, {threshold: .15});
    this.observer.observe(this.stage);
   } else this.visible = true;
   this.autoTimer = setTimeout(() => this.autoStep(), this.autoInterval * (.6 + index * .55) + Math.random() * 700);
  }
  autoStep() {
   if (!this.isConnected || this.autoStopped) return;
   if (this.visible && !document.hidden && !(window.matchMedia('(hover: hover) and (pointer: fine)').matches && this.matches(':hover')) && !this.contains(document.activeElement)) {
    const list = this.cycleSizes();
    if (list.length > 1) {
     const i = list.findIndex(size => size.label === this.size?.label);
     this.size = list[(i + 1) % list.length]; this.choice[this.room]='auto';
     this.slow = true; this.render();
     clearTimeout(this.slowTimer); this.slowTimer = setTimeout(() => { this.slow = false; }, 1300);
    }
   }
   this.autoTimer = setTimeout(() => this.autoStep(), this.autoInterval);
  }
  stopAuto() { this.autoStopped = true; this.slow = false; clearTimeout(this.autoTimer); }
  disconnectedCallback() {
   window.removeEventListener('resize', this.onResize);
   this.catalogMedia?.removeEventListener('change',this.onCatalogLayout);
   cancelAnimationFrame(this.renderFrame); this.renderFrame = 0;
   clearTimeout(this.autoTimer); clearTimeout(this.slowTimer); this.observer?.disconnect();
   for (const animation of this.motion || []) animation.cancel(); this.motion = []; this.hasRendered = false;
   this.initialized = false; this.loadToken++;
   this.removeEventListener('click', this.onClick);
   this.modelSelect?.removeEventListener('change', this.onModel);
   this.furnitureSelect?.removeEventListener('change', this.onFurniture);
  }
 });
}








